import { fixContent } from "../../utils";
import { not_available_vertical } from "../../pngs";
import { CoalitionStampsProgress } from "../CoalitionStampsProgress";
import { SingleProductImg } from "../CoalitionComplements";
import { extractDataForKey, showOnlyIfNotProd, printableId } from "../../utils";
import "./CoalitionCardStamps.scss";

export const CoalitionCardStamps = ({
  id,
  product,
  title,
  description,
  used,
  needed,
  availableToRedeem,
  showModal,
  buttonRef,
}) => {
  const ready = availableToRedeem > 0 || used >= needed;
  const balanceFixed = ready ? availableToRedeem * needed + used : used;

  const titleToShow = () => {
    const defTxt = `Compra ${needed} y llévate uno de regalo`;
    const defaultTxt = title ? title : defTxt;
    const label = extractDataForKey(description, "title", defaultTxt);
    return fixContent(label, 65);
  };

  return (
    <div
      className="card-stamps"
      ref={buttonRef}
      onClick={() => showModal(id)}
      onKeyPress={() => showModal(id)}
      role="button"
      tabIndex={0}
    >
      <div className="main">
        <div className="product">
          <SingleProductImg load={product} error={not_available_vertical} />
        </div>
        {showOnlyIfNotProd(
          <label className="qa-detail">{printableId(id)}</label>
        )}
        <div className="title">
          <span>{titleToShow()}</span>
        </div>
      </div>
      <div className={`footer ${ready ? "success" : ""}`}>
        <CoalitionStampsProgress used={balanceFixed} needed={needed} />
        <label>
          <b>{balanceFixed}</b>
          {` de ${needed}`}
        </label>
      </div>
    </div>
  );
};
